import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import gpsIcon from "./img/gps.png";
import moment from 'moment';
import 'moment-timezone';
import './View.css';
import { getStripeError } from './static';
import googleIcon from "./img/google-play.png";
import iosIcon from "./img/ios-appstore.png";
export default class App extends Component {

    constructor(props) {
        super(props);
        this.hours = [];
        this.mins = [];
        this.handleDurationChange = this.handleDurationChange.bind(this);
        this.calculatePrice = this.calculatePrice.bind(this);
        this.initForm = this.initForm.bind(this);
        this.env = process.env.REACT_APP_ENVIRONMENT;
        const urlParams = new URLSearchParams(window.location.search);
        if (this.env === 'STAGING' && urlParams && urlParams.get('env') && urlParams.get('env') === 'dev') {
            this.baseUrl = process.env.REACT_APP_DEV_API_URL;
            this.stripeKey = process.env.REACT_APP_TEST_STRIPE_KEY;
        } else {
            this.baseUrl = process.env.REACT_APP_API_URL;
            this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
        }
        for (let i = 0; i <= 1440; i++) {
            this.hours.push({
                value: i,
                display: i + ' Hr'
            })
        }
        for (let j = 0; j < 60; j += 5) {
            if (j < 10) {
                this.mins.push({
                    value: j,
                    display: '0' + j + ' mins'
                })
            } else {
                this.mins.push({
                    value: j,
                    display: j + ' mins'
                })
            }
        }
        this.resetState = {
            extensionDetails: null,
            booked: true,
            booking_details: [],
            editLicensePlate: false,
            showExtendBookingPopup: false,
            updatedLicensePlate: '',
            loading: false,
            isPaymentProcessing: false,
            fields: {
                hours: 0,
                mins: 0,
            },
            errors: {}
        }
        this.state = {
            booked: false,
            booking_details: [],
            editLicensePlate: false,
            showExtendBookingPopup: false,
            updatedLicensePlate: '',
            loading: false,
            isPaymentProcessing: false,
            fields: {
                hours: 0,
                mins: 0,
            },
            errors: {}
        }
    }

    openErrorModal(payErrorMsg) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.manageBodyBackground(true);
        this.setState({ payErrorMsg });
    }
    manageBodyBackground(isShow) {
        if (isShow) {
            document.querySelector('#root').classList.add('dark');
        } else {
            document.querySelector('#root').classList.remove('dark');
        }
    }

    handleChange(e) {
        this.setState({
            updatedLicensePlate: e.target.value.toUpperCase()
        })
    }

    handleFieldChange = (e) => {
        let fields = {...this.state.fields};
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });
    }

    handleClose() {
        this.setState({ booked: false, bookedID: null }, () => {
            this.manageBodyBackground(false);
        })
    }

    handleErrorModalClose() {
        this.setState({ payErrorMsg: false }, () => {
            this.manageBodyBackground(false);
        })
    }

    handleDurationChange(e) {
        let fields = { ...this.state.fields };
        fields[e.target.name] = e.target.value;
        if (e.target.name === 'hours' || e.target.name === 'mins') {
            const validDuration = !(e.target.value === '0' && ((e.target.name === 'hours' && fields['mins'] == 0) || (e.target.name === 'mins' && fields['hours'] == 0)));
            
            const endDateTime = moment.unix(this.state.booking_details.end_date_time / 1000);

            const hoursDiff = parseInt(fields['hours']) - parseInt(this.state.fields['hours']);
            const minsDiff = parseInt(fields['mins']) - parseInt(this.state.fields['mins']);

            const newEndDateTime = endDateTime.add(hoursDiff, 'hours').add(minsDiff, 'minutes');

            if (newEndDateTime.isBefore(moment().tz(this.state.booking_details.timezone))) {
                toast.dismiss();
                toast.error("End date time should be greater than current time");
                return; 
            }
            this.setState({
                fields,
                booking_details: {
                    ...this.state.booking_details,
                    end_date_time: newEndDateTime.unix() * 1000
                },
                extensionDetails: validDuration ? this.state.extensionDetails : null
            }, () => validDuration &&  this.calculatePrice());
        } else {
            this.setState({
                fields
            });
        }
    }


    extendBooking() {
        this.setState({
            showExtendBookingPopup: true
        }, () => {
            this.initForm();
        })
    }

    componentDidMount() {
        this.getDetails();
        this.refreshAfterSleep();
    }

    refreshAfterSleep(){
		var SAMPLE_RATE = 5000; 
		var lastSample = Date.now();
	  
		function refresh() {
		  if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
			window.location.reload();
		  }
		  lastSample = Date.now();
		  setTimeout(refresh, SAMPLE_RATE);
		}
		refresh();
	}

    initForm() {
        this.stripe = window.Stripe(this.stripeKey);
        var elements = this.stripe.elements();

        var style = {
            base: {
                iconColor: '#666EE8',
                color: '#000',
                lineHeight: '40px',
                fontSize: '16px',

                '::placeholder': {
                    color: '#000',
                    fontWeight: 300,
                    fontSize: '13px'
                },
            },
        };

        this.paymentRequest = this.stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: '',
                amount: this.state.extensionDetails?.extension_charge || 0
            },
            requestPayerName: true
        });

        var elements = this.stripe.elements();
        this.payRequestButton = elements.create('paymentRequestButton', {
            paymentRequest: this.paymentRequest
        });


        this.paymentRequest.canMakePayment().then((result) => {
            this.checkIfAppleGooglePayOption(result);
        });

        this.payRequestButton.on('click', (event) => {
            this.handlePayRequestButtonClick(event);
        });

        this.paymentRequest.on('paymentmethod', (ev) => {
            this.onPaymentRequestStart(ev);
        });

        this.card = elements.create('card', { style: style, hidePostalCode: false });

        this.card.mount('#card-element');

        this.card.addEventListener('change', function (event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });
    }

    getDetails() {
        const urlParams = new URLSearchParams(window.location.search);
        this.setState({loading: true})
        fetch(`${this.baseUrl}/user/booking/details/hash?booking_hash=${urlParams.get('hash')}`)
            .then(response => response.json())
            .then(resp => {
                if (resp.data && resp.status === "SUCCESS") {
                    this.setState({
                        booking_details: resp.data,
                        updatedLicensePlate: resp.data.vehicle_no,
                        loading: false,
                    })
                } else {
                    let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
                    this.setState({
                        loading: false
                    })
                    toast.dismiss();
                    toast.error(errMsg);
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false
                })
                toast.dismiss();
                toast.error('Something went wrong');
            });
    }

    checkIfAppleGooglePayOption(result) {
        if (result) {
            this.setState({
                walletType: result.applePay ? 'applePay' : result.googlePay ? 'googlePay' : ''
            }, () => {
                document.getElementById('partners-button').style.display = 'block';
                this.payRequestButton.mount('#payment-request-button');
            })

        } else {
            document.getElementById('payment-request-button').style.display = 'none';
        }
    }

    handlePayRequestButtonClick(event) {
        if (this.state.isPaymentProcessing) return;
        const isValid = this.validateForm(false);
        if (!isValid) {
            event.preventDefault();
            return;
        }
        try {
            this.paymentRequest.update({
                total: {
                    label: 'Total amount',
                    amount: this.state.extensionDetails?.extension_charge || 0,
                }
            });
        } catch (error) {
            console.error('Error occurred in handlePayRequestButtonClick:', error);
        }
    }


    onPaymentRequestStart(ev) {
        let payErrorMsg = '';
        let request = {
            "card_id": this.state.extensionDetails.card_id,
            "payment_method_id": ev.paymentMethod.id,
            "end_date_time": this.state.booking_details.end_date_time,
            "profile_id": 0,
            "hash": this.state.booking_details.hash
        }
        fetch(`${this.baseUrl}/transient/parking/extension/authenticate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request)
        })
            .then(response => response.json())
            .then(resp => {
                if (resp.data && resp.status === "SUCCESS" && resp.data.status === 'succeeded') {
                    this.handleSubmit('', this.card, resp.data, ev, this.state.walletType);
                } else if (resp.data && resp.status === "SUCCESS" && resp.data.status === 'requires_action') {
                    this.stripe
                        .confirmCardPayment(resp.data.client_secret)
                        .then((ccp) => {
                            if (ccp.error) {
                                ev.complete('fail');
                                payErrorMsg = ccp && ccp.error && ccp.error.message ? ccp.error.message : 'Something went wrong';
                                payErrorMsg = getStripeError(payErrorMsg);
                                this.openErrorModal(payErrorMsg);
                            } else {
                                this.handleSubmit('', this.card, resp.data, ev, this.state.walletType);
                            }
                        });
                } else {
                    ev.complete('fail');
                    payErrorMsg = getStripeError('');
                    this.openErrorModal(payErrorMsg);
                }
            })
            .catch((error) => {
                ev.complete('fail');
                payErrorMsg = getStripeError('');
                this.openErrorModal(payErrorMsg);
            });
    }

    setOutcome(result, req) {
        let payErrorMsg = '';
        const submitBtn = document.getElementById("pay-submit");
        if (result && result.paymentMethod && result.paymentMethod.id) {
            let request = {
                "card_id": this.state.extensionDetails.card_id,
                "payment_method_id": result.paymentMethod.id,
                "end_date_time": this.state.booking_details.end_date_time,
                "profile_id": 0,
                "hash": this.state.booking_details.hash
            }
            fetch(`${this.baseUrl}/transient/parking/extension/authenticate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request)
            })
                .then(response => response.json())
                .then(resp => {
                    if (resp.data && resp.status === "SUCCESS" && resp.data.status === 'succeeded') {
                        this.handleSubmit('', this.card, resp.data)
                    } else if (resp.data && resp.status === "SUCCESS" && resp.data.status === 'requires_action') {
                        this.stripe
                            .confirmCardPayment(resp.data.client_secret, {
                                payment_method: req
                            })
                            .then((ccp) => {
                                if (ccp.error) {
                                    this.manageBodyBackground(false);
                                    this.setState({ isPaymentProcessing: false });
                                    payErrorMsg = ccp && ccp.error && ccp.error.message ? ccp.error.message : 'Something went wrong';
                                    payErrorMsg = getStripeError(payErrorMsg);
                                    this.openErrorModal(payErrorMsg);
                                    submitBtn.disabled = false;
                                } else {
                                    this.handleSubmit('', this.card, resp.data)
                                }
                            });
                    } else {
                        this.manageBodyBackground(false);
                        this.setState({ isPaymentProcessing: false });
                        payErrorMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
                        payErrorMsg = getStripeError(payErrorMsg);
                        this.openErrorModal(payErrorMsg);
                        submitBtn.disabled = false;
                    }
                })
                .catch((error) => {
                    this.manageBodyBackground(false);
                    this.setState({ isPaymentProcessing: false });
                    payErrorMsg = getStripeError('');
                    this.openErrorModal(payErrorMsg);
                    submitBtn.disabled = false;
                });
        } else if (result.error) {
            this.manageBodyBackground(false);
            this.setState({ isPaymentProcessing: false });
            payErrorMsg = result.error.message ? result.error.message : 'Something went wrong';
            payErrorMsg = getStripeError(payErrorMsg);
            this.openErrorModal(payErrorMsg);
            submitBtn.disabled = false;
        }
    }

    preSubmit() {
        document.getElementById("pay-submit").disabled = true;
        if (this.state.isPaymentProcessing) return;
        const submitBtn = document.getElementById("pay-submit");
        const isValid = this.validateForm(true);
        if (!isValid) {
            submitBtn.disabled = false;
            return;
        }
        let isPayment = this.state.extensionDetails.extension_charge === 0 ? false : true;
    
        this.manageBodyBackground(true);
        this.setState({ isPaymentProcessing: true });
        if (isPayment) {
            const { fields } = this.state;
            var options = {
                name: fields.cardholder_name,
            };

            let req = {
                type: 'card',
                card: this.card,
                billing_details: {
                    name: fields.cardholder_name,
                }
            }
            this.stripe.createPaymentMethod(req).then((result) => this.setOutcome(result, req));
        } else {
            const isWithoutPayment = !isPayment;
            this.handleSubmit('', this.card, false, false, '', isWithoutPayment);
        }
    }

    prepareRequest(id, data, walletType, isWithoutPayment) {
        const { fields } = this.state;
        const request = {
            hash: this.state.booking_details.hash,
            card_id: this.state.extensionDetails.card_id,
            apple_pay: walletType === 'applePay' ? true : false,
            google_pay: walletType === 'googlePay' ? true : false,
            source_id: id ? id : '',
            end_date_time: this.state.booking_details.end_date_time,
            cardholder_name: fields["cardholder_name"] ? fields["cardholder_name"] : '',
            payment_method_id: data ? data.payment_method_id : '',
            payment_details: {
                charge_id: data ? data.charge_id : '',
                client_secret: data ? data.client_secret : '',
                customer: data ? data.customer : '',
                payment_intent: data ? data.payment_intent : '',
                payment_method_id: data ? data.payment_method_id : '',
                status: data ? data.status : ''
            }
        }
        if (isWithoutPayment) {
            delete request.payment_method_id;
            delete request.payment_details;
        }
        return request;
    }

    handleSubmit(id, card, data, btnEvent, walletType, isWithoutPayment) {
        let payErrorMsg = '';
        const submitBtn = document.getElementById("pay-submit");
        let request = this.prepareRequest(id, data, walletType, isWithoutPayment);
        fetch(`${this.baseUrl}/transient/parking/extend`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request)
        })
            .then(response => response.json())
            .then(resp => {
                if (resp.data && resp.status === "SUCCESS") {
                    window.scrollTo(0, 0);
                    this.setState({ ...this.resetState }, () => {
                        if (card) card.clear();
                        this.getDetails();
                        submitBtn.disabled = false;
                        if (btnEvent) btnEvent.complete('success');
                    });
                } else {
                    let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
                    if (btnEvent) btnEvent.complete('fail');
                    this.manageBodyBackground(false);
                    this.setState({ isPaymentProcessing: false });
                    payErrorMsg = getStripeError(errMsg);
                    this.openErrorModal(payErrorMsg);
                    submitBtn.disabled = false;
                }
            })
            .catch((error) => {
                if (btnEvent) btnEvent.complete('fail');
                this.manageBodyBackground(false);
                this.setState({ isPaymentProcessing: false });
                payErrorMsg = getStripeError('');
                this.openErrorModal(payErrorMsg);
                submitBtn.disabled = false;
            });
    }


    updateLicensePlate() {
        this.setState({
            loading: true
        })
        if (this.state.updatedLicensePlate === '') {
            toast.error('Please enter license plate');
            this.setState({
                loading: false
            })
            return;
        }
        const urlParams = new URLSearchParams(window.location.search);
        let request = {
            "hash": this.state.booking_details.hash,
            "vehicle_no": this.state.updatedLicensePlate,
            "external_user_id": '',
            "parking_id": this.state.booking_details.parking_arena_id
        };
        fetch(`${this.baseUrl}/transient/parking/vehicle/update`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request)
        })
            .then(response => response.json())
            .then(resp => {
                if (resp.data && resp.status === "SUCCESS") {
                    toast.success('License plate updated successfully');
                    this.getDetails();
                    this.setState({
                        editLicensePlate: false,
                        loading: false
                    })
                } else {
                    let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
                    this.setState({
                        loading: false
                    })
                    toast.dismiss();
                    toast.error(errMsg);
                }
            })
            .catch((error) => {
                toast.dismiss();
                this.setState({
                    loading: false
                })
                toast.error('Something went wrong');
            });
    }


    validateForm(isCard) {
        let fields = this.state.fields;
        let formIsValid = true;
        this.errors = {};
        const cardWrapper = document.querySelector('#card-element');
        const cardWrapperError = document.querySelector('#card-errors');
        let isPayment = this.state.extensionDetails.extension_charge === 0 ? false : true;

        // if ((!fields["hours"] || fields["hours"] == 0) && (!fields["mins"] || fields["mins"] == 0)) {
        //   formIsValid = false;
        //   this.errors["duration"] = "select the parking duration";
        // }
        if (isCard && isPayment) {
            if (cardWrapper.classList.contains('StripeElement--empty')) {
                formIsValid = false;
                cardWrapperError.innerHTML = "enter your card number";
            }
            if (cardWrapper.classList.contains('StripeElement--invalid')) {
                formIsValid = false;
                if (!cardWrapperError.innerHTML.trim()) cardWrapperError.innerHTML = "enter valid details";
            }
            if (!fields["cardholder_name"] || (fields["cardholder_name"] && fields["cardholder_name"].trim() === '')) {
                formIsValid = false;
                this.errors["cardholder_name"] = "enter the cardholder name";
            }
        } else if (cardWrapperError && this.card) {
            cardWrapperError.innerHTML = "";
            this.card.clear();
        }
        this.setState({
            errors: this.errors
        });
        return formIsValid;
    }



    calculatePrice() {
        fetch(`${this.baseUrl}/transient/parking/extend/charge?hash=${this.state.booking_details.hash}&end_date_time=${this.state.booking_details.end_date_time}`)
            .then(response => response.json())
            .then(resp => {
                if (resp.data && resp.status === "SUCCESS") {
                    this.setState({
                        extensionDetails: resp.data
                    })
                } else {
                    let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
                    toast.dismiss();
                    toast.error(errMsg);
                }
            })
            .catch((error) => {
                toast.dismiss();
                toast.error('Something went wrong');
            });
    }



    render() {
        let isPayment = this.state.extensionDetails && this.state.extensionDetails.extension_charge > 0 ? true : false;
        let hasValidDuration = this.state.fields.hours > 0 || this.state.fields.mins > 0;
        return (
            <div className="view-container">
                {this.state.loading && <div style={{ zIndex: 2 }} className="loader">Loading...</div>}
                {this.state.isPaymentProcessing &&
                    <div className="loader-v2">
                        <div className='spinner'></div>
                        <p>Please do not refresh this page or press back button while we are processing your payment.</p>
                    </div>}
                <div style={{ display: this.state.booked ? 'block' : 'none' }} className="success-message">
                    <span onClick={this.handleClose.bind(this)} id="sm-close">&times;</span>
                    <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
                        <circle cx="38" cy="38" r="36"></circle>
                        <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{ strokeDashoffset: 0, strokeDasharray: 56.0029 }}></path>
                    </svg>
                    <h3 className="success-message__title">Extended Successfully</h3>
                </div>
                <div style={{display: this.state.payErrorMsg ? 'block' : 'none'}} className="error-message">
                    <span onClick={this.handleErrorModalClose.bind(this)} id="sm-close">&times;</span>
                    <svg fill="#FF0000" viewBox="0 0 478.125 478.125" xmlSpace="preserve" className="error-message__icon icon-checkmark">
                        <g>
                        <g>
                            <g>
                            <circle cx="239.904" cy="314.721" r="35.878" />
                            <path d="M256.657,127.525h-31.9c-10.557,0-19.125,8.645-19.125,19.125v101.975c0,10.48,8.645,19.125,19.125,19.125h31.9
                            c10.48,0,19.125-8.645,19.125-19.125V146.65C275.782,136.17,267.138,127.525,256.657,127.525z" />
                            <path d="M239.062,0C106.947,0,0,106.947,0,239.062s106.947,239.062,239.062,239.062c132.115,0,239.062-106.947,239.062-239.062
                            S371.178,0,239.062,0z M239.292,409.734c-94.171,0-170.595-76.348-170.595-170.596c0-94.248,76.347-170.595,170.595-170.595
                            s170.595,76.347,170.595,170.595C409.887,333.387,333.464,409.734,239.292,409.734z" />
                            </g>
                        </g>
                        </g>
                    </svg>
                    <div className="error-message__content">
                        <p>{this.state.payErrorMsg}</p>
                    </div>
                </div>
                <div style={{ textAlign: 'center', paddingBottom: 20 }}>
                    <img style={{ height: 85 }} src="https://portal.parkquility.com/public/pq_logo.png" />
                </div>
                <div style={{ textAlign: 'center' }} className="location">
                    <img style={{ height: 35 }} src={gpsIcon} />
                    <span>{this.state.booking_details.destination}</span>
                </div>
                <ul style={{ marginTop: '10px' }} className="pay-timings">
                    <li>
                        <span className="list-initial">Booking Id</span>
                        <span>{this.state.booking_details.booking_id}</span>
                    </li>
                    <li>
                        <span className="list-initial">Booking Status</span>
                        <span>{this.state.booking_details.booking_status && this.state.booking_details.booking_status.charAt(0).toUpperCase() + this.state.booking_details.booking_status.slice(1)}</span>
                    </li>
                    <li>
                        <span className="list-initial" >Total Fee</span>
                        <span>{this.state.booking_details.parking_charge > -1 ? `$${(this.state.booking_details.parking_charge / 100).toFixed(2)}` : ''}</span>
                    </li>
                    <li>
                        <span className="list-initial" >Parking Fee</span>
                        <span>{this.state.booking_details.parking_fee > -1 ? `$${(this.state.booking_details.parking_fee / 100).toFixed(2)}` : ''}</span>
                    </li>
                    {this.state.booking_details.hasOwnProperty('custom_sales_tax_field_name') && this.state.booking_details.hasOwnProperty('sales_tax_fee') && this.state.booking_details.sales_tax_fee !== null && this.state.booking_details.sales_tax_fee > 0 && <li>
                        <span className="list-initial" >{this.state.booking_details.custom_sales_tax_field_name}</span>
                        <span>{`$${(this.state.booking_details.sales_tax_fee / 100).toFixed(2)}`}</span>
                    </li>}
                    {this.state.booking_details.surcharge_fee !== null && this.state.booking_details.surcharge_fee > 0 && <li>
                        <span className="list-initial" >{this.state.booking_details.custom_surcharge_tax_field_name}</span>
                        <span>{`$${(this.state.booking_details.surcharge_fee / 100).toFixed(2)}`}</span>
                    </li>}
                    {(this.state.booking_details.convenience_fee > 0 || this.state.booking_details.additional_transaction_fee > 0) &&<li>
                        <span className="list-initial" >Convenience Fee</span>
                        <span>{`$${((this.state.booking_details.convenience_fee + this.state.booking_details.additional_transaction_fee)/ 100).toFixed(2)}`}</span>
                    </li>}
                    {this.state.booking_details.discount_amount !== null && this.state.booking_details.discount_amount > 0 && (
                        <li>
                            <span className="list-initial">Discount Amount</span>
                            <span>{`$${(this.state.booking_details.discount_amount / 100).toFixed(2)}`}</span>
                        </li>
                    )}
                    {(this.state.booking_details.hasOwnProperty('coupon_code') ) && (
                        <li>
                            <span className="list-initial">Coupon</span>
                            <span>{this.state.booking_details.coupon_code.toUpperCase()}</span>
                        </li>
                    )}
                    <li>
                        <span className="list-initial">License Plate</span>
                        {!this.state.editLicensePlate ? (
                            <span className="vehicle-no-span">
                                <span className="vehicle-no">{this.state.booking_details.vehicle_no}</span>
                                {this.state.booking_details.booking_status !== "completed" && (
                                    <div
                                        style={{ marginBottom: '3px' }}
                                        className="icon-container"
                                        onClick={() => this.setState({ editLicensePlate: !this.state.editLicensePlate })}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                            <path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z" />
                                        </svg>
                                    </div>
                                )}
                            </span>
                        ) : (
                            <span className="vehicle-no-span">
                                <span className="vehicle-no">
                                    <input
                                        value={this.state.updatedLicensePlate}
                                        onChange={(e) => this.handleChange(e)}
                                        className="license-plate-input"
                                        type="text"
                                    />
                                </span>
                                <div
                                    style={{ marginBottom: '3px' }}
                                    className="icon-container"
                                    onClick={() => this.updateLicensePlate()}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                        <path d="M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                                    </svg>
                                </div>
                            </span>
                        )}
                    </li>
                    <li>
                        <span className="list-initial">Contact Number</span>
                        <span>{`${this.state.booking_details.country_code}-${this.state.booking_details.contact_number}`}</span>
                    </li>
                    {this.state.booking_details.hasOwnProperty('email') && <li>
                        <span className="list-initial">Email</span>
                        <span>{this.state.booking_details.email}</span>
                    </li>}
                    <li>
                        <span className="list-initial" >Start Time</span>
                        <span>{this.state.booking_details.start_date_time ? moment.unix(this.state.booking_details.start_date_time / 1000).tz(this.state.booking_details.timezone).format('MMM DD, YYYY, hh:mm A') : ''}</span>
                    </li>
                    <li>
                        <span className="list-initial" >End Time</span>
                        <span>{this.state.booking_details.end_date_time ? moment.unix(this.state.booking_details.end_date_time / 1000).tz(this.state.booking_details.timezone).format('MMM DD, YYYY, hh:mm A') : ''}</span>
                    </li>
                </ul>
                {this.state.booking_details.extension_message && <h4 className="extension-messgae-container" >{this.state.booking_details.extension_message}</h4>}
                {this.state.showExtendBookingPopup && (
                    <div>
                        <div className="pay-duration">
                            <span>
                                <select name="hours" value={this.state.fields["hours"]} onChange={this.handleDurationChange}>
                                    {this.hours.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                                </select>
                            </span>
                            <span>
                                <select name="mins" value={this.state.fields["mins"]} onChange={this.handleDurationChange} style={{ marginLeft: '20px' }}>
                                    {this.mins.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                                </select>
                            </span>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                    </div>)}

                {this.state.extensionDetails && this.state.extensionDetails.extension_charge > 0 && (
                    <div>
                        <h4 style={{ paddingTop: 10, paddingBottom: 10 }}>Extension Summary</h4>
                        <ul className="pay-timings">
                            <li>
                                <span className="list-initial">Extension Charges</span>
                                <span>{this.state.extensionDetails.extension_charge > -1 ? `$${(this.state.extensionDetails.extension_charge / 100).toFixed(2)}` : ''}</span>
                            </li>
                            <li>
                                <span className="list-initial">Parking Fee</span>
                                <span>{this.state.extensionDetails.parking_fee > -1 ? `$${(this.state.extensionDetails.parking_fee / 100).toFixed(2)}` : ''}</span>
                            </li>
                            <li>
                                <span className="list-initial">Convenience Fee</span>
                                <span>{this.state.extensionDetails.convenience_fee > -1 ? `$${(this.state.extensionDetails.convenience_fee / 100).toFixed(2)}` : ''}</span>
                            </li>
                            {this.state.extensionDetails.hasOwnProperty('sales_tax_fee') && this.state.extensionDetails.sales_tax_fee !== null && this.state.extensionDetails.sales_tax_fee > 0 && (
                                <li>
                                    <span className="list-initial">Sales Tax Fee</span>
                                    <span>${(this.state.extensionDetails.sales_tax_fee / 100).toFixed(2)}</span>
                                </li>
                            )}
                            {this.state.extensionDetails.additional_transaction_fee !== null && this.state.extensionDetails.additional_transaction_fee > 0 && (
                                <li>
                                    <span className="list-initial">Additional Transaction Fee</span>
                                    <span>${(this.state.extensionDetails.additional_transaction_fee / 100).toFixed(2)}</span>
                                </li>
                            )}
                            {this.state.extensionDetails.surcharge_fee !== null && this.state.extensionDetails.surcharge_fee > 0 && (
                                <li>
                                    <span className="list-initial">Surcharge</span>
                                    <span>${(this.state.extensionDetails.surcharge_fee / 100).toFixed(2)}</span>
                                </li>
                            )}
                            {this.state.extensionDetails.discount_amount !== null && this.state.extensionDetails.discount_amount > 0 && (
                                <li>
                                    <span className="list-initial">Discount Amount</span>
                                    <span>${(this.state.extensionDetails.discount_amount / 100).toFixed(2)}</span>
                                </li>
                            )}
                        </ul>
                    </div>
                )
                }
                <div style={{ display: isPayment ? 'block' : "none" }}>
                    <h4 style={{ paddingTop: 20, paddingBottom: 10 }}>Payment</h4>
                    <div style={{ display: "none" }} id='partners-button'>
                        <div>
                            <div style={{ width: '150px' }}>
                                <div id="payment-request-button"></div>
                            </div>
                        </div>
                        <div class="separator">
                            <div class="line"></div>
                            <h6> or pay using your card </h6>
                            <div class="line"></div>
                        </div>
                    </div>

                    <div className="card-info">
                        <div id="card-element">
                        </div>
                    </div>
                    <div className="error-msg" id="card-errors" role="alert"></div>
                    <div class="group">
                        <label>
                        <input onChange={this.handleFieldChange} value={this.state.fields["cardholder_name"]} name="cardholder_name" class="field" placeholder="Cardholder name" />
                        </label>
                    </div>
                    <div style={{ paddingLeft: '15px', marginTop: '4px' }} className="error-msg">{this.state.errors['cardholder_name']}</div>
                </div>
                {this.state.extensionDetails?.extension_charge > -1 && hasValidDuration && <button style={{ marginBottom: '10px' }} onClick={this.preSubmit.bind(this)} id="pay-submit" type="button">{isPayment ? 'Pay ' + (this.state.extensionDetails.extension_charge > -1 ? `$${(this.state.extensionDetails.extension_charge / 100).toFixed(2)}` : '') : 'Extend Booking'}</button>}
                {!this.state.showExtendBookingPopup && this.state.booking_details.booking_status !== 'completed' && <button id="pay-submit" type="button" onClick={() => this.extendBooking()} className="view-container-buttons">Extend Booking</button>}
                <p style={{ padding: '10px 0' }}>For Extensions, Reservations, Assistance and Booking History, Download our App</p>
                <div className="download-app">
                    <a target="_blank" href="https://apps.apple.com/in/app/parkquility/id1543951488"><img src={iosIcon} /></a>
                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.parkquility"><img src={googleIcon} /></a>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <div className="outcome">
                    <div className="error" />
                    <div className="success">
                        <p>Success</p>
                    </div>
                </div>
                <ToastContainer autoClose={2000} closeButton={true} style={{ fontSize: 14 }} />
            </div>
        )
    }
}
